import {
	Dialog,
	DialogBody,
	DialogContent,
	DialogTitle,
} from "@exopengithub/exokit";
import { Button } from "@exopengithub/exokit/v2";
import { showErrorNotification } from "molecules/notifications/notificationEvents";
import { DialogActions } from "molecules/dialog/DialogActions";
import { useTranslation } from "react-i18next";

import type { LegalEntityEntity } from "../../../common/service/nexus/types.js";
import { useEntityHierarchy } from "../entityHierarchyProviderUtils";
import type { EntityHierarchy } from "src/common/service/nexus/utils/hierarchy.js";

import { useLoadedCompanyDomain } from "src/routes/routeDataHooks.js";

type Props = {
	isOpen: boolean;
	onClose: () => void;
	group: EntityHierarchy<LegalEntityEntity, Record<string, null>> | null;
};

export const RemoveGroupModal = ({ group, isOpen, onClose }: Props) => {
	const { t } = useTranslation();

	const companyDomain = useLoadedCompanyDomain();

	const {
		removeGroupMutation: [deleteGroup, { isLoading }],
		parentLegalEntityId: legalEntityId,
		type,
	} = useEntityHierarchy();

	return (
		<Dialog open={isOpen} onClose={onClose}>
			<DialogContent>
				<DialogTitle>{t("Remove group")}</DialogTitle>
				<DialogBody>
					<div className="text-sm mb-2">
						{t("Are you sure you want to remove {{groupName}}?", {
							groupName: group?.name,
						})}
					</div>
				</DialogBody>
				<DialogActions withCancelButton>
					<Button
						type="button"
						onClick={async () => {
							if (group) {
								const result = await deleteGroup({
									companyDomainId: companyDomain.id,
									legalEntityId,
									groupId: group.id,
									type,
								});

								if ("error" in result) {
									showErrorNotification({
										message: t("Error"),
									});
								} else {
									onClose();
								}
							}
						}}
						destructive
						isLoading={isLoading}
					>
						{t("Remove")}
					</Button>
				</DialogActions>
			</DialogContent>
		</Dialog>
	);
};
